<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<template>
<div :style="!dk?'width: 42% !important;margin-left: 29%;':''">
  
  <div >
    

<div v-for="(item, index) in shopList" :key="index" class="shopl bg-white margin-tb-sm yin text-black round-sm padding">
    
    <div class="flex align-center justify-between padding-top-sm">
      <img class="shop-img" :src="item.shopLogo"/>
      <div class="margin-right-sm" style="text-align: left;">
        <div class=" text-bold text-cut" style="width: 200px;font-size: 16px;" :style="dk?'':'font-size: 27px;width: 500px;margin-bottom:25px'">{{item.shopName}}</div>
        <div v-if="item.distance==0 && dk" class="text-red padding-tb-xs text-sm" style="margin-top: 5px;"> <text class="cuIcon-locationfill lg "></text>未授权位置信息</div>
        <div v-if="item.distance!=0" class="text-red padding-tb-xs text-sm" style="margin-top: 5px;"> <text class="cuIcon-locationfill lg "></text>距你{{item.distance}}km</div>
        <div class="text-gray text-cut text-sm" style="width: 200px;margin-top: 5px;" :style="dk?'':'font-size: 27px;width: 500px;'">{{item.shopAddress}}{{item.shopDetailAddress}}</div>
      </div>
      <a :href="'https://uri.amap.com/marker?position=' + item.longitude+','+item.latitude+'&name='+item.shopName" >
        <img class="daoh2 margin-left-sm" src="https://quanyouxiang.oss-cn-shanghai.aliyuncs.com/goods/20230628/file1673949019036192768.png" :style="dk?'':'margin-left:14px'"/>
        <div class="text-red" style="font-size: 14px;width: 50px;">去这里</div>
      </a>
    </div>

</div>

<div style="height: 250px;"></div>

</div>


</div>
</template>
<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'yxShop',
  data () {
    return {
      requestHeadUrl: 'https://zhenqing.kequbang.com',
      // requestHeadUrl: 'http://localhost:8122',
      isOpenVipModular: false,
      isVip: 0,
      storeId: '',
      userId: '',
      isMiniProgram: true,
      appLink: '',
      info: {},
      goodsAttributes: [],
      TabCur:0,
      modalName: '',
      pageNo: 0,
      goodsName: '',
      title: '',
      values: '',
      valueKey: '',
      price: '',
      userPhone: '',
      titleName: '',
      shopList:[],
      lat:'',
      lon:'',
    }
  },
  created () {
    const thisObj = this
    let userAgentInfo = navigator.userAgent;
    let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let getArr = Agents.filter(i => userAgentInfo.includes(i));
    // true： 移动端 false： pc端
    thisObj.dk = getArr.length ? true : false;
    let params = this.$route.query;
    thisObj.goodsId = params.goodsId
    thisObj.lon = params.lon
    thisObj.lat = params.lat
    document.title = '优选门店'
    thisObj.getShops()
    // thisObj.onLoad()
  },
  methods: {
    onLoad: function () {
      
      // const payParam = {
      //       appId: 'wxa55c200673db6dc7',
      //       package: 'result.resultData.package',
      //       paySign: 'result.resultData.sign',
      //       signType: 'MD5',
      //       timeStamp: 'result.resultData.timeStamp',
      //       nonceStr: 'result.resultData.nonceStr'
      //     }
      // this.navigateToMiniProgram(JSON.stringify(payParam))
      var rr = window.location.href.split('/')
      //9d03442a91c345709dcbcd85daab9cc4
      // var gid = rr[rr.length-1].split('-')[0]
      var gid = rr[rr.length-1].substring(1)
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/admin/goodsLink/getById?id='+ gid +'&storeId=storezhenqing&linkId='+rr[rr.length-1], {}).then(res => {
        // console.log(res)
        res.goodsImgs = res.goodsImgs.split(",");
        res.goodsDetailImgs = res.goodsDetailImgs.split(",");
        thisObj.info = res 
        thisObj.goodsAttributes = JSON.parse(res.goodsAttributes)
        thisObj.titleName = res.goodsName
        document.title= res.goodsName
        this.getLongitudeLatitude()
        // console.log(thisObj.info)
        // console.log(thisObj.goodsAttributes)
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
      
    },
    getLongitudeLatitude() {
      var that = this
      //如果该对象存在，那么地理位置服务可用。
      if ('geolocation' in navigator) {
        /* 地理位置服务可用 */
        var options = {
          enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
          timeout: 5000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
          maximumAge: 0 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
        }
        function success(position) {
          
          //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
          //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
          var lat = position.coords.latitude //当前位置的纬度
          var lon = position.coords.longitude //当前位置精度
          that.lat = lat
          that.lon = lon
          that.getShops()
          // alert(lat + "A233A" + lng)
        }
        function error(err) {
          console.log(err)
          var errorType = ['您拒绝共享位置信息', '获取不到位置信息', '获取位置信息超时']
          console.log(errorType[err.code - 1])
          // alert(errorType[err.code - 1])
          that.getShops()
        }
 
        navigator.geolocation.getCurrentPosition(success, error, options)
      } else {
        /* 地理位置服务不可用 */
        console.log('无法获取您的位置，请检查定位是否开启或刷新重试')
      }
    },

    getShops() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/group/shop/getAllShopsByGoods?lat='+ thisObj.lat +'&lon='+ thisObj.lon +'&goodsId='+thisObj.goodsId, {}).then(res => {
        // console.log(res)
        thisObj.shopList = res
        // res.goodsImgs = res.goodsImgs.split(",");
        // res.goodsDetailImgs = res.goodsDetailImgs.split(",");
        // thisObj.info = res 
        // thisObj.goodsAttributes = JSON.parse(res.goodsAttributes)
        // thisObj.titleName = res.goodsName
        // document.title= res.goodsName
        // console.log(thisObj.info)
        // console.log(thisObj.goodsAttributes)
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },

    goApp() {
      location.href=this.appLink
    },
    tabSelect(e) {
      this.TabCur = e
    },
    showModal() {
      this.modalName = 'bottomModal'
    },
    hideModal() {
      this.modalName = ''
    },
    // 页面跳转
    pageJump (uri, obj,index) {
      const thisObj = this
      var that = this;
    var info = that.info
    var goodsAttributes = that.goodsAttributes

    // thisObj.goodsName = info.goodsName
    // thisObj.title = goodsAttributes[obj].title
    // thisObj.values = goodsAttributes[obj].values[index]
    // thisObj.valueKey = goodsAttributes[obj].valueKey[index]
    // thisObj.price = info.groupBuyingPrice
    // thisObj.pageNo = 1
    thisObj.userPhone = ''
      let queryData = {
        goodsName: info.goodsName,
        title: goodsAttributes[obj].title,
        values: goodsAttributes[obj].values[index],
        valueKey: goodsAttributes[obj].valueKey[index],
        price: info.groupBuyingPrice
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    onClickLeft () {
      this.pageNo = 0
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    
  }
}
</script>

<style>
.bg-e {
  background: #eeeeee;
}
.margin-top {
    margin-top: 30px;
}
.grid {
    display: flex;
    flex-wrap: wrap;
}
.justify-between {
    justify-content: space-between;
}
.align-center {
    align-items: center;
}
.text-xxl {
    font-size: 44px;
}
.margin {
    margin: 30px;
}
.half-angle {
    box-shadow: 1px 2px 18px 0px rgba(0, 0, 0, 0.12);
    border-radius: 40px;
}
.bg-white {
    background-color: var(--white);
    color: var(--darkGray);
}
.padding {
    padding: 30px;
}
.text-cut {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.text-xl {
    font-size: 36px;
}
.flex {
    display: flex;
}
.grid.col-2>div {
    width: 50%;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.text-center {
    text-align: center;
}
.text-bold {
    font-weight: bold;
}
.text-xl {
    font-size: 36px;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding {
    padding: 30px;
}
.padding-top {
    padding-top: 30px;
}
.b-b {
    border-bottom: 2px solid #CFCFCF;
}
.padding-sm {
    padding: 20px;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.text-bold {
    font-weight: bold;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.cu-modal.bottom-modal.show {
    margin-bottom: 0;
}
.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}
.padding-right-sm {
    padding-right: 20px;
}
.padding-top-xs {
    padding-top: 10px;
}
.bg-orange {
    background-color: #f37b1d;
    color: #ffffff;
}
.an_shop {
  width: 100%;
  line-height: 130px;
  color: #fff;
  background-color: #ff6600;
  border-radius: 30px;
  text-align: center;
  font-size: 48px;
  height: 130px;
}
.an_shop2 {
  width: 40%;
  line-height: 80px;
  color: #fff;
  background-color: #ff6600;
  border-radius: 50px;
  text-align: center;
  font-size: 36px;
}
.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}

.shuxing {
  color: #ff6600;
  font-size: 29px;
  width: 29%;
  margin: 12px;
  border-radius: 20px;
  padding: 20px 8px;
  margin-top: 30px;
  background-color: #ffefe4;
  border: 2px solid #ff6600;
}
.half-angle {
    box-shadow: 1px 2px 18px 0px rgba(0, 0, 0, 0.12);
    border-radius: 40px;
}
.margin-top-sm {
    margin-top: 20px;
}
.margin-top-xs {
    margin-top: 10px;
}
.padding-top-sm {
    padding-top: 20px;
}

.cu-modal.show {
    opacity: 1;
    transition-duration: 0.3s;
    -ms-transform: scale(1);
    transform: scale(1);
    overflow-x: hidden;
    overflow-y: auto;
    pointer-events: auto;
}
.cu-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1110;
    opacity: 0;
    outline: 0;
    text-align: center;
    -ms-transform: scale(1.185);
    transform: scale(1.185);
    backface-visibility: hidden;
    perspective: 2000px;
    background: rgba(0, 0, 0, 0.6);
    transition: all 0.3s ease-in-out 0s;
    pointer-events: none;
}
.cu-modal.bottom-modal.show {
    margin-bottom: 0;
}
.cu-modal.bottom-modal::before {
    vertical-align: bottom;
}
.cu-modal::before {
    content: "\200B";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
}
.cu-modal.bottom-modal .cu-dialog {
    width: 100%;
    border-radius: 0;
}
.cu-dialog {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin-left: auto;
    margin-right: auto;
    width: 680px;
    max-width: 100%;
    background-color: #f8f8f8;
    border-radius: 10px;
    overflow: hidden;
}
.text-right {
    text-align: right;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding-right-sm {
    padding-right: 20px;
}
.padding-top-xs {
    padding-top: 10px;
}
.cuIcon-close:before {
    content: "\e646";
}
.text-black, .line-black, .lines-black {
    color: #333333;
}
.text-bold {
    font-weight: bold;
}
.text-center {
    text-align: center;
}
.text-xl {
    font-size: 36px;
}
.bg-orange {
    background-color: #f37b1d;
    color: #ffffff;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.padding-lr-sm {
    padding-left: 20px;
    padding-right: 20px;
}
.round {
    border-radius: 500px;
}





button.tools-item {
  line-height: 1.1;
  margin: 0;
  padding: 0;
  background: transparent;
  font-size: 24px;
  color: #fff;
  position: fixed;
  bottom: 140px;
  right: 55px;
}

 .tools-item cover-view {
  display: flex;
  align-items: center;
}
 .tools-item cover-image {
  width: 40px;
  margin: 0 12px 0 40px;
}
.kqb-share2 {
  opacity: 0.3;
  width: 100%;
  height: 100%;
  background-color: #333;
  position: fixed;
  bottom: 0px;
}
.bgC-white {
  background-color: #fff;
}
[class*="cuIcon1-"] {
  font-family: "myFont";
  font-size: inherit;
  font-style: normal;
}
.daoh2 {
  height: 30px;
  width: 30px;
  margin-left: 40px;
}
.shop-img {
  width: 130px;
  height: 130px;
  border-radius: 20px;
  margin: 0 20px 0 0;
}
.cuIcon-locationfill:before {
    content: "\e650";
    font-size: inherit;
    font-style: normal;
}
.text-red, .line-red, .lines-red {
    color: #e54d42;
}
.co {
    color: #7eb0f7;
}
.text-gray, .line-gray, .lines-gray {
    color: #aaaaaa;
}

.shopl {
  padding: 20px;
  margin: 20px;
  /* border: 1px solid #CFCFCF; */
  border-radius: 20px;
}
</style>
